import { apiClient } from '@services/api-client'

import {
  settlementsUrl,
  useSettlementMutation
} from './useSettlementMutation'
import type { SettlementDetail } from '../types'

export function useUnpublishSettlement() {
  return useSettlementMutation<string, SettlementDetail>({
    toastKey: 'settlementUnpublished',
    request: async (id) =>
      (
        await apiClient.post<SettlementDetail>(
          `${settlementsUrl}/${id}/unpublish`,
          {}
        )
      ).data
  })
}
